<div class="container-fluid">
    <div class="row no-gutter">
        <div class="d-none d-md-flex col-md-4 col-lg-6 bg-image"></div>
        <div class="col-md-8 col-lg-6">
            <div class="login d-flex align-items-center py-5">
                <div class="container">
                    <div class="row">
                        <div class="col-md-9 col-lg-8 mx-auto">
                            <h3 class="login-heading mb-4" *ngIf="entorno != 'Produccion'"><b style="color: red;">Entorno:  </b>{{entorno}}</h3>
                            <h1 class="login-heading mb-4">Inmobiliaria</h1>
                            <h3 *ngIf="!modoRecuperacion" class="login-heading mb-4">Ingrese credenciales de acceso.</h3>
                            <h3 *ngIf="modoRecuperacion " class="login-heading mb-4">Complete los pasos para recuperar su cuenta</h3>
                            <app-recover-password *ngIf="modoRecuperacion"></app-recover-password>
                            <a color="primary" *ngIf="modoRecuperacion" (click)="goToLogin()">Volver a Iniciar Sesion</a>
                            <app-iniciar-sesion *ngIf="!modoRecuperacion"></app-iniciar-sesion>
                            <br>
                            <a class="small" *ngIf="!modoRecuperacion" (click)="RecuperarCuenta()">Recuperar contraseña.</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>